<template>
  <v-slider
    v-model="sliderValue"
    class="brazil-v-slider"
    thumb-size="30px"
    thumb-label="always"
    track-fill-color="#048a05"
    track-color="#ffffff"
    color="#048a05"
    thumb-color="#048a05"
    :track-size="40"
    :tick-size="40"
    label=""
    :step="step"
    :min="min"
    :max="max"
    :value="value"
  >
    <template v-slot:thumb-label="item">
      <div class="slider-label">
        R$ {{ item.value }}
      </div>
    </template>
  </v-slider>
</template>

<script>
import { VSlider } from 'vuetify/lib';

export default {
  components: {
    VSlider,
  },
  props: {
    step: {
      type:     Number,
      required: true,
    },
    min: {
      type:     Number,
      required: true,
    },
    max: {
      type:     Number,
      required: true,
    },
    value: {
      type:     Number,
      required: true,
    },
  },
  data() {
    return {
      sliderValue: 0,
    };
  },
  watch: {
    sliderValue(val) {
      this.valueChanged(val);
    },
  },
  mounted() {
    this.sliderValue = this.value;
  },
  methods: {
    valueChanged(event) {
      this.$emit('valueChanged', event);
    },
  },
};
</script>

<style lang="scss" module>
  .brazil-v-slider .v-input__control {
    margin: 0 20px;
  }
  .brazil-v-slider .v-slider--horizontal .v-slider__track-container {
    height: 24px;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #c2c2c2;
  }
  .brazil-v-slider .v-slider--horizontal .v-slider__thumb{
    height: 30px;
    width: 30px;
    left: -15px;
  }
  .brazil-v-slider .v-slider--horizontal .slider-label {
    background-color: #048a05;
    width: 86px;
    height: 30px;
    border-radius: 15px;
    text-align: center;
    padding: 4px;
    font-size: 16px;
  }
  .brazil-v-slider .v-slider--horizontal .v-slider__thumb-label {
    bottom: auto;
    top: -35px;
  }
  .brazil-v-slider .v-slider--horizontal .v-slider__thumb-label > * {
    font-weight: bold;
  }
  .brazil-v-slider .v-slider--horizontal .v-slider__thumb:before {
    content: none;
  }
  .brazil-v-slider .v-slider {
    cursor: pointer;
  }
  .registration-panel .registration-form .brazil-v-slider .v-slider input {
    display: none;
  }
</style>
